// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"5bc28eb45b64fd71","660":"d1fe0c4ff7f6c599","777":"b77d5e5fe6978fd1"}[chunkId] + ".js";
};